import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PageShell from '../../components/PageShell.mjs';
import ClarificationThread from '../components/ClarificationThread.mjs';

/**
 * One clarification question on a page of its own - where the emails and the
 * inbox send people. The thread itself links to the claim or report it is
 * about, so the reader can check the item and come back to answer.
 */
const ClarificationThreadPage = () => {
  const { threadId } = useParams();
  return (
    <PageShell
      title="Question"
      subtitle={<Link to="/clarifications" className="underline hover:no-underline">All questions</Link>}
      width="3xl"
    >
      <div className="bg-white rounded-xl shadow p-4 sm:p-6">
        <ClarificationThread threadId={threadId} />
      </div>
    </PageShell>
  );
};

export default ClarificationThreadPage;
